import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import {
  currencyOption,
  CompanyTransaction,
} from "../../../../../utility/data";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { formatNumber } from "../../../../../utility/helper";
import {
  addTransaction,
  updateTransaction,
} from "../../../../../services/transaction";
import {
  fetchGroups,
  resetGroupsState,
} from "../../../../../redux/slices/groupsSlice";
import {
  FormActions,
  FormDatePicker,
  FormDropdown,
  FormInput,
} from "../../../../../components/Stepper/fields/inputField";
import { useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";

const CreateTransactionModal = ({
  visible,
  singleTransactionData,
  viewTransaction,
  GetstatsData,
  GetRoiData,
  actionTypes,
  fetchTransactionData,
  onHide,
  SelectType,
  loading,
  setLoading,
  toast,
  assetName,
}) => {
  const { groupsData, groupLoading } = useSelector((state) => state.groups);
  const { currency } = useSelector((state) => state.user);
  const filteredData = groupsData.filter(
    (group) => group.id == assetName?.included_in
  );
  const InitialDateValue = viewTransaction?.transactions?.find(
    (item) => item.is_initial
  );
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const initialTransactionData = {
    assetType: CompanyTransaction[0],
    includeIn: filteredData[0] ? filteredData[0] : groupsData[0],
    date: moment().toDate(),
    type: singleTransactionData?.type
      ? singleTransactionData?.type
      : SelectType,
    currency: currency ? currency : currencyOption[0].value,
    reason: singleTransactionData?.reason ? singleTransactionData?.reason : "",
    remark: singleTransactionData?.remark ? singleTransactionData?.remark : "",
    amount: singleTransactionData?.amount
      ? formatNumber(singleTransactionData?.amount)
      : "",
  };
  const [createTransactionData, setCreateTransactionData] = useState(
    initialTransactionData
  );
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (singleTransactionData) {
      setCreateTransactionData((prevData) => ({
        ...prevData,
        currency: singleTransactionData.currency || prevData.currency,
        date: singleTransactionData.date
          ? moment(singleTransactionData.date).toDate()
          : prevData.date,
        reason: singleTransactionData.reason || "",
        amount: formatNumber(singleTransactionData.amount) || "",
        type: singleTransactionData.type || "",
      }));
    }
  }, [singleTransactionData]);

  useEffect(() => {
    if (currency && currency !== createTransactionData.currency) {
      setCreateTransactionData((prevData) => ({
        ...prevData,
        currency,
      }));
    }
  }, [currency]);

  useEffect(() => {
    if (accessToken) {
      dispatch(fetchGroups(accessToken)).then((resultAction) => {
        if (fetchGroups.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      });
    }

    return () => {
      dispatch(resetGroupsState());
    };
  }, [dispatch, accessToken, navigate]);

  useEffect(() => {
    setCreateTransactionData((prevData) => ({
      ...prevData,
      type: singleTransactionData?.type ?? SelectType,
    }));
  }, [SelectType, visible]);

  useEffect(() => {
    if (groupsData?.length > 0) {
      setCreateTransactionData((prev) => ({
        ...prev,
        includeIn: filteredData[0] ? filteredData[0] : groupsData[0],
      }));
    }
  }, [groupsData, assetName]);

  const handleInputChange = (e) => {
    const { name, value } = e.target || e;

    setCreateTransactionData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    if (errors[name] && value && value.toString().trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleAmountChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

   let rawValue = value.replace(/[^0-9.]/g, "");

    if (rawValue === "" || isNaN(rawValue)) {
      setCreateTransactionData((prevData) => ({
        ...prevData,
        amount: "",
      }));
      return;
    }

    if (rawValue.length > 12) {
      rawValue = rawValue.slice(0, 12);
    }

    value = formatNumber(rawValue);

    let AutoCalPL = null;

    AutoCalPL = formatNumber(Number(rawValue));

    setCreateTransactionData((prevData) => ({
      ...prevData,
      amount: value,
      ...(AutoCalPL !== null && { amount: AutoCalPL }),
    }));

    if (errors[name] && value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleAssetTypeChange = (e) => {
    const selectedAssetType = e.value;

    setCreateTransactionData((prevData) => ({
      ...prevData,
      assetType: selectedAssetType,
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!createTransactionData.date) {
      newErrors.date = "Date is required";
    }
    if (!createTransactionData.type) {
      newErrors.type = "Type is required";
    }
    if (!createTransactionData.currency) {
      newErrors.currency = "Currency is required";
    }

    if (!createTransactionData.includeIn) {
      newErrors.includeIn = "Groups is required";
    }
    if (!createTransactionData.amount) {
      newErrors.amount = "Amount is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (validateForm()) {
      setLoading(true);
      if (!assetName) {
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: "Please add the first initial transaction",
          life: 3000,
        });
        return;
      }

      const formattedData = {
        ...createTransactionData,

        amount: createTransactionData.amount
          ? createTransactionData.amount.replace(/[,']/g, "")
          : "",
        type: createTransactionData.type ? createTransactionData.type : "",
        date: createTransactionData.date
          ? moment(createTransactionData.date).format("YYYY-MM-DD HH:mm:ss")
          : null,
      };
      try {
        const response = await (actionTypes === "Create"
          ? addTransaction(formattedData, assetName, accessToken)
          : updateTransaction(
              singleTransactionData.id,
              formattedData,
              assetName,
              accessToken
            ));

        if (response.data.status === true) {
          fetchTransactionData();
          GetRoiData();
          GetstatsData();
          handleClose();
          toast.current.show({
            className: "bg-green-300 text-white",
            severity: "success",
            summary: "Success",
            detail: response.data.message,
            life: 3000,
          });
        }
      } catch (error) {
        const status = error?.response?.status;
        handleErrorRedirect(status, navigate);
        toast.current.show({
          className: "bg-yellow-700 text-white",
          severity: "warn",
          summary: "Warning",
          detail: error.message,
          life: 3000,
        });
      } finally {
        setLoading(false);
      }
    }
  };

  if (!visible) return null;

  const handleClose = () => {
    setCreateTransactionData(initialTransactionData);
    setErrors({});
    onHide();
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50 px-2 md:px-0">
        <div className="dark:bg-custom-radial bg-[#F6F6F6] md:w-2/3 xl:w-1/2 w-full max-h-[calc(100%-30%)] overflow-y-auto shadow-lg p-6 text-[rgba(255,255,255,1)] border border-lightPrimary/40 dark:border-info/40">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-2xl text-lightPrimary dark:text-primary-gradient font-semibold">
              {actionTypes} Transaction
            </h2>
            <FaTimes
              onClick={handleClose}
              className="cursor-pointer text-lightPrimary dark:text-darkWaring"
              fontSize={20}
            />
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSave();
            }}
          >
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
              <FormDropdown
                label="Asset Type"
                name="assetType"
                value={createTransactionData.assetType}
                onChange={handleAssetTypeChange}
                options={CompanyTransaction}
                optionsLabel="name"
                disabled
                error={errors.assetType}
                className={`rounded-lg w-full p-0 bg-transparent border  border-info dark:border-gray-300 text-white focus:outline-none focus:border-b-2 ${
                  createTransactionData.assetType ? "asset_Dropdown" : ""
                }`}
                placeholder="Select Asset Type"
              />
              <FormDropdown
                label="Include In*"
                name="includeIn"
                value={createTransactionData.includeIn}
                onChange={(e) =>
                  handleInputChange({ name: "includeIn", value: e.value })
                }
                options={groupsData}
                disabled
                error={errors.includeIn}
                optionsLabel="name"
                className={`w-full p-0 bg-transparent border  border-info dark:border-gray-300 text-white rounded-lg focus:outline-none focus:border-b-2 ${
                  createTransactionData.includeIn ? "asset_Dropdown" : ""
                }`}
                placeholder="Select Include In"
              />
              <FormDatePicker
                label="Date*"
                name="date"
                value={createTransactionData.date}
                onChange={(e) =>
                  handleInputChange({ name: "date", value: e.value })
                }
                error={errors.date}
                minDate={
                  InitialDateValue?.date
                    ? moment(InitialDateValue.date).toDate()
                    : moment().toDate()
                }
                maxDate={moment().toDate()}
                disabled={actionTypes === "Update"}
              />

              <FormInput
                label="Type*"
                name="type"
                value={createTransactionData.type}
                onChange={handleInputChange}
                error={errors.type}
                disabled={true}
              />

              <FormInput
                label="Reason"
                name="reason"
                value={createTransactionData.reason}
                onChange={handleInputChange}
                error={errors.reason}
              />
              <FormDropdown
                label="Currency*"
                name="currency"
                value={createTransactionData.currency}
                onChange={handleInputChange}
                disabled
                options={currencyOption}
                error={errors.currency}
                optionsLabel="label"
                optionsValue="value"
                className={`create_transaction w-full p-0 bg-transparent border-b  border-info dark:border-gray-300 text-white rounded-none focus:outline-none focus:border-b-2 ${
                  createTransactionData.currency ? "asset_Dropdown" : ""
                }`}
                placeholder="Select Currency"
              />

              <FormInput
                label="Amount*"
                name="amount"
                value={createTransactionData.amount || ""}
                onChange={handleAmountChange}
                error={errors.amount}
              />
            </div>

            <FormActions
              loading={loading}
              onCancel={handleClose}
              actionType={actionTypes}
              submitType="submit"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateTransactionModal;
